import _ from 'lodash';
const arr = [
  'FULL_TIME',
  'PART_TIME',
  'TRAINEE',
  'POST_RETIREMENT_EMPLOYMENT',
  'LABOR_DISPATCH',
  'FOREIGN_WORKERS',
  'IMPORTED_WORKERS',
  'HOURLY_WORK',
  'TEMPORARY_WORKER',
  'SOCIAL_WORK',
  'STUDENT_PART_TIME',
  'SECONDMENT',
  'SELF_EMPLOYED',
  'CONTRACT_SYSTEM',
  'OUTSOURCING_OF_LABOR_SERVICES',
  'OTHER'
];
export default _.map(arr, v => {
  return {
    label: `employee.${v}`,
    value: v
  };
});
